(function($) {

    $.fn.orderform = function (options) {

        var $elem = this;
        var settings = $.extend({
        }, options);

        $('#shipping').change(function() {
            if($(this).prop('checked')) {
                TweenLite.to('.order-shipping', 0.3, { autoAlpha: 1, width: $elem.find('.order-shipping > .wrapper').width(), marginLeft: 40 });
            } else {
                TweenLite.to('.order-shipping', 0.3, { autoAlpha: 0, width: 0, marginLeft: 0 });
            }
        });

        if($('#shipping').prop('checked')) {
            TweenLite.to('.order-shipping', 0.3, { autoAlpha: 1, width: $elem.find('.order-shipping > .wrapper').width(), marginLeft: 40 });
        }

        // Appending the shipping form when shipping is checked
        $('.order-details-button').click(function() {
            if($('#shipping').prop('checked')) {
                $('.order-shipping input').each(function(i,v) {
                    var name = $(v).attr('name');
                    var val = $(v).val();
                    var input = $('<input type="hidden" name="'+name+'" value="'+val+'">');
                    $('.order-invoice > form').append(input);
                });

                var country = $('#shipping_country').val();
                var input = $('<input type="hidden" name="shipping_country" value="'+country+'">');
                $('.order-invoice > form').append(input);
            }

            // Tracking Facebook added payment info
            fbq('track', 'AddPaymentInfo');

            $('.order-invoice > form').submit();
        });

    };

}( jQuery ));